import axios from "axios";
import ObjectUtil from "../../../../utils/common/ObjectUtil";
import {ordersServicesPath} from "../../../../Constants";

const optimizationServiceRestUrl = ordersServicesPath + '/organizations/optimizations'

export default class OptimizationService {

    static async getAllNotArchive() {
        return axios.get(optimizationServiceRestUrl + '/not-archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByOptimizationState(optimizationState) {
        return axios.get(optimizationServiceRestUrl + '/by-optimization-state' + '?optimizationState=' + optimizationState, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllNotArchiveTypeCalculation() {
        return axios.get(optimizationServiceRestUrl + '/not-archive-calculation', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async downloadFileSelco(id, selcoFileFieldsOrderId) {
        const query = selcoFileFieldsOrderId ? `?selcoFileFieldsOrderId=${selcoFileFieldsOrderId}` : ""
        return axios.get(optimizationServiceRestUrl + "/" + id + '/download/file-selco' + query, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(optimizationServiceRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createOptimizationByIds(ids, optimization) {
        let data = ObjectUtil.createRequestObjectOptimizationIds(ids, optimization);
        return await axios.post(optimizationServiceRestUrl + '/create-by-ids-requests-cutting',
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async createOptimization(data) {
        return await axios.post(optimizationServiceRestUrl,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async unableStatus(id, optimizationState) {
        return axios.patch(optimizationServiceRestUrl + '/' + id + '/unable-status?optimizationState=' + optimizationState, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setArchive(ids) {
        const data = ObjectUtil.createRequestObjectIds(ids)
        return axios.patch(optimizationServiceRestUrl + '/set-archive', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async deleteNumberOrder(id) {
        return axios.patch(optimizationServiceRestUrl + '/' + id + "/delete-number-order", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async addNumberOrder(id) {
        return axios.patch(optimizationServiceRestUrl + '/' + id +"/add-number-order", [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}